import { Database } from "@nozbe/watermelondb";
import LokiJSAdapter from "@nozbe/watermelondb/adapters/lokijs";
import { offlineMigrations } from "./migrations";
import { OfflineResource } from "./models/offline-resource";
import { offlineSchema } from "./schema";

let database: Database | null = null;
let disabled = false;

function canUseOfflineDatabase(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.indexedDB !== "undefined" &&
    !disabled
  );
}

export function getOfflineDatabase(): Database | null {
  if (!canUseOfflineDatabase()) {
    return null;
  }

  if (database) {
    return database;
  }

  const adapter = new LokiJSAdapter({
    schema: offlineSchema,
    migrations: offlineMigrations,
    dbName: "sparelynk-offline",
    useWebWorker: false,
    useIncrementalIndexedDB: true,
    onQuotaExceededError(error) {
      console.warn("SpareLynk offline storage quota was exceeded.", error);
    },
    onSetUpError(error) {
      disabled = true;
      console.warn("SpareLynk offline database could not be initialized.", error);
    },
    extraIncrementalIDBOptions: {
      onDidOverwrite() {
        console.warn(
          "SpareLynk offline data was refreshed because another tab changed the database.",
        );
      },
      onversionchange() {
        window.location.reload();
      },
    },
  });

  database = new Database({
    adapter,
    modelClasses: [OfflineResource],
  });

  return database;
}
